"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../data/store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var selectShortcutsOption_1 = require("../data/mutators/selectShortcutsOption");
var owa_options_controls_1 = require("owa-options-controls");
var KeyboardShortcutsFull = /** @class */ (function (_super) {
    tslib_1.__extends(KeyboardShortcutsFull, _super);
    function KeyboardShortcutsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyboardShortcutsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var selectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_shortcuts_description),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { label: owa_options_strings_1.default.options_shortcuts_label, selectedKey: selectedKey, options: [
                    {
                        key: "" + 0 /* Hotmail */,
                        text: owa_options_strings_1.default.options_shortcut_choice_hotmail,
                    },
                    {
                        key: "" + 2 /* Yahoo */,
                        text: owa_options_strings_1.default.options_shortcut_choice_yahoo,
                    },
                    {
                        key: "" + 3 /* Gmail */,
                        text: owa_options_strings_1.default.options_shortcut_choice_gmail,
                    },
                    {
                        key: "" + 4 /* Owa */,
                        text: owa_options_strings_1.default.options_shortcut_choice_outlook,
                    },
                    {
                        key: "" + 1 /* Off */,
                        text: owa_options_strings_1.default.options_shortcut_choice_off,
                    },
                ], onChange: this.onChange })));
    };
    KeyboardShortcutsFull.prototype.onChange = function (ev, option) {
        selectShortcutsOption_1.default(parseInt(option.key, 10));
    };
    KeyboardShortcutsFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default(); },
        })
    ], KeyboardShortcutsFull);
    return KeyboardShortcutsFull;
}(React.Component));
exports.default = KeyboardShortcutsFull;
//# sourceMappingURL=KeyboardShortcutsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/view/KeyboardShortcutsFull.js
// module id = 4971
// module chunks = 2